import { TFileTypes } from './messageFiles';
import { IWsFileMessage } from '../actions/wsMessage/types';
import { IChatFilesResponse } from '../repositories/chats/entities/file/ChatFilesResponse';
import { ICancellationToken } from '../utils/cancelationToken';

export enum EUploadFilesStatus {
  Pending = 'pending',
  Succeed = 'succeed',
  Failed = 'failed',
  WsSucceed = 'wsSucceed',
}

export type TMessageFiles = {
  blobFiles?: TPendingBlobFile[];
  uploadedFiles?: IWsFileMessage[];
  status: EUploadFilesStatus;
};

export type TPendingBlobFile = {
  file: File;
  cancellationToken: ICancellationToken;
  type: TFileTypes;
};

export type { IChatFilesResponse as TGetLatestChatFilesResponse };
